var render = function render(){var _vm=this,_c=_vm._self._c;return _c('iframe',{staticClass:"embeded-google-map lazyload",staticStyle:{"border":"0"},attrs:{"title":"Google map","data-src":_vm.src,"allowfullscreen":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }